exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_groupEditPanel_3guU0jybLbq16SMyp_yMbr {\n  position: relative;\n  width: 100%;\n  float: left;\n}\n\n.IA_content_Gfc8_2GmyegS6IeJfjZ6u {\n  position: relative;\n  float: left;\n  width: 400px;\n  height: 100%;\n  padding-left: 40px;\n  box-sizing: border-box;\n}", ""]);

// Exports
exports.locals = {
	"IA_groupEditPanel": "IA_groupEditPanel_3guU0jybLbq16SMyp_yMbr",
	"IA_content": "IA_content_Gfc8_2GmyegS6IeJfjZ6u"
};